import { Chip } from '@mui/material';
import { useColorScheme } from '@mui/material/styles';

import useStyles from './VMPGenericChip.styles';

/**
 * Chip component with solid background
 * Displays either the value (as a Criticality Type) or the text passed as props
 * Uses VMP_SOLID_COLORS from chartcolors.constants to determine the background color
 * Chip will not be rendered if neither value nor text is passed or if value is an empty string
 * It will be rendered if value is an empty string and text is passed, it will default to a solid grey chip
 */

const VMPGenericChip = ({
  value,
  type,
  text
}: {
  value: string;
  type?: 'filled' | 'outlined';
  text?: string;
}) => {
  const { mode: themeMode } = useColorScheme();
  const { classes } = useStyles({ themeMode, value });

  const contentToDisplay = value !== '' || (text && text?.trim().length > 0);

  if (!contentToDisplay) {
    return null;
  }

  return (
    <Chip
      label={text || value}
      className={type === 'outlined' ? classes.outlinedChip : classes.solidChip}
    />
  );
};

export default VMPGenericChip;
